import { render } from "./UploadBulkData.vue?vue&type=template&id=72996e95&scoped=true&ts=true"
import script from "./UploadBulkData.vue?vue&type=script&lang=ts"
export * from "./UploadBulkData.vue?vue&type=script&lang=ts"

import "./UploadBulkData.vue?vue&type=style&index=0&id=72996e95&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72996e95"]])

export default __exports__